import React from "react";
import { LoginStep1FormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { useGoogleLogin } from "@react-oauth/google";
import { Inputs, Buttons, Icons } from "components";

const LoginStep1Form = ({ onSubmit, onGoogleLogin, onLineLogin }) => {
  const schema = yup.object().shape({
    username: yup.string().required("*Required"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const googleLogin = useGoogleLogin({
    flow: "implicit",
    onSuccess: (tokenResponse) => {
      if (onGoogleLogin) {
        onGoogleLogin(tokenResponse.access_token);
      }
    },
    onError: () => {},
  });

  const { t } = useTranslation(["common", "form"]);
  return (
    <LoginStep1FormStyled>
      <div className="login_header">
        {t("Sign up or Login", { ns: "form" })}
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                placeholder={t("Enter your Email", { ns: "form" })}
                errors={errors.username?.message}
              />
            )}
            name="username"
            defaultValue=""
          />
        </div>
        <Buttons.BgStandard
          type="submit"
          label={t("Continue", { ns: "common" })}
        />
        <div className="or_text">{t("OR", { ns: "common" })}</div>
        <div className="btn_wrap">
          <Buttons.IconButton
            icon={<Icons.Google />}
            label={t("Continue with Google", { ns: "common" })}
            onClick={() => googleLogin()}
          />
        </div>
        <Buttons.IconButton
          icon={<Icons.Line />}
          label={t("Continue with LINE", { ns: "common" })}
          onClick={onLineLogin}
        />
      </form>
    </LoginStep1FormStyled>
  );
};

LoginStep1Form.propTypes = {};
export default LoginStep1Form;
